import { render, staticRenderFns } from "./BaseAccordion.vue?vue&type=template&id=41b8584d&scoped=true"
import script from "./BaseAccordion.vue?vue&type=script&lang=js"
export * from "./BaseAccordion.vue?vue&type=script&lang=js"
import style0 from "./BaseAccordion.vue?vue&type=style&index=0&id=41b8584d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b8584d",
  null
  
)

export default component.exports